"use client";

import { useEffect, useState } from "react";

import { STORAGE_KEYS } from "../constants";

const COUNTER_ID = process.env.NEXT_PUBLIC_YM_COUNTER_ID;
const CONSENT_EVENT = "slot-cookie-consent-changed";

function hasAnalyticsConsent(): boolean {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEYS.cookieConsent);
    if (!raw) return false;
    const parsed = JSON.parse(raw) as { analytics?: boolean } | null;
    return Boolean(parsed?.analytics);
  } catch {
    return false;
  }
}

declare global {
  interface Window {
    ym?: (counterId: number, action: string, params?: Record<string, unknown>) => void;
  }
}

export function YandexMetrika() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!COUNTER_ID) return;
    const sync = () => setEnabled(hasAnalyticsConsent());
    sync();
    window.addEventListener(CONSENT_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(CONSENT_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  useEffect(() => {
    if (!enabled || !COUNTER_ID) return;
    if (document.getElementById("ym-script")) return;

    const counterId = Number(COUNTER_ID);
    const script = document.createElement("script");
    script.id = "ym-script";
    script.async = true;
    script.src = "https://mc.yandex.ru/metrika/tag.js";
    script.onload = () => {
      window.ym?.(counterId, "init", {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
      });
    };
    document.head.appendChild(script);
  }, [enabled]);

  return null;
}
